// 封装获取当前月份和上个月份的函数
export function getCurrentAndPreviousMonth(date = new Date()) {
    const currentMonth = new Date(date.getFullYear(), date.getMonth(), 1);
    const previousMonth = new Date(date.getFullYear(), date.getMonth() - 1, 1);

    const formatDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0"); // 补零确保月份为两位数
        return `${year}-${month}`;
    };

    return {
        currentMonth: formatDate(currentMonth),
        previousMonth: formatDate(previousMonth)
    };
}
export function formatTimestampToMonth(timestamp) {
    const date = new Date(timestamp);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // 确保月份为两位数
    return `${year}-${month}`;
}
export function formatTimestamp(timestamp) {
    const date = new Date(timestamp);
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    const hours = date.getHours().toString().padStart(2, "0");
    const minutes = date.getMinutes().toString().padStart(2, "0");
    const seconds = date.getSeconds().toString().padStart(2, "0");

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}
export function getMonthFirstAndLastDay(dateStr) {
    // 将输入的日期字符串转换为Date对象
    const date = new Date(dateStr);

    // 获取当月第一天
    const firstDay = new Date(date.getFullYear(), date.getMonth(), 1);

    // 获取下月第一天，然后减去1毫秒得到当月最后一天
    const lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);

    // 格式化日期
    const formatDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        return `${year}-${month}-${day} 00:00:00`;
    };

    return {
        firstDay: formatDate(firstDay),
        lastDay: formatDate(lastDay)
    };
}
